import * as THREE from 'three';
export class loadRender{
    renderer;
    constructor() {
        this.Start();
    }
    Start(){
        let self = this;
        self.renderer = new THREE.WebGLRenderer({antialias: true,alpha: true});
        self.renderer.setPixelRatio(window.devicePixelRatio);
        self.renderer.setClearColor( 0xffffff, 0);
        self.renderer.outputEncoding = THREE.sRGBEncoding;
       // self.renderer.toneMapping = THREE.NoToneMapping;
        self.renderer.toneMappingExposure = 1;
       // self.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        // self.renderer.gammaInput = true;
        // self.renderer.gammaOutput = true;
    }
    getRender(){
        return this.renderer;
    }
}
